<script setup lang="ts">
import ListSearchCommon from 'src/components/ListSearchCommon.vue';
import ProjectResult from 'src/components/search-results/ProjectCard.vue';
import ProjectSkeleton from 'src/components/skeleton-loading/ProjectSkeleton.vue';
import type { ProjectCardData } from 'src/types/entity.types';
const convertData = (data: any) => {
    return data as ProjectCardData;
};
</script>

<template>
    <ListSearchCommon key="entity" type="entity">
        <template #item="{ data }">
            <ProjectResult :data="convertData(data)" />
        </template>
        <template #skeleton-loading>
            <ProjectSkeleton />
        </template>
    </ListSearchCommon>
</template>
